import { useState } from "react";
import {
  Table,
  Space,
  Button,
  Modal,
  message,
} from "antd";
import TypeBookModalForm from './TypeBookModalForm'
import TypeBookService from "../../../services/TypeBookService";

const getColumns = (showModalForm,showModalDelete,setTypeBookTarget) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setTypeBookTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setTypeBookTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
}

export default function TypeBooks({ list = [], getData, setTypeBooks }) {
const [typeBookTarget, setTypeBookTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    TypeBookService.deleteTypeBook(typeBookTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Tipo de Libro eliminado.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setTypeBooks(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de Tipo de Libros.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar el Tipo de Libro . " + res.data.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setTypeBookTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setTypeBookTarget(null);
        setIsModalFormVisible(false);
        setTypeBooks(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de carreras.", 5);
      });
  };

  const handleCancelForm = () => {
    setTypeBookTarget(null);
    setIsModalFormVisible(false);
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nueva Tipo de Libro
      </Button>
      <Table
        columns={getColumns(showModalForm,showModalDelete,setTypeBookTarget)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <TypeBookModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          typeBookTarget={typeBookTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Tipo de Libro"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar la carrera{" "}
            <strong>
              {typeBookTarget?.name}
            </strong>
            ?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
